const RatingSectionData=[
    {
        id:1,
        img:"./assests/images/bark.svg",
        title:"Bark",
        img2:"./assests/images/stars-45.png",
        p:4.7,
        sub:5,
    },
    {
        id:2,
        img:"./assests/images/trustpilot.svg",
        title:"Trustpilot",
        img2:"./assests/images/stars-45.png",
        p:8.7,
        sub:7,
    },
    {
        id:3,
        img:"./assests/images/sitejabber.svg",
        title:"Sitejabber",
        img2:"./assests/images/stars-45.png",
        p:4.7,
        sub:5,
    },
    {
        id:4,
        img:"./assests/images/reviews-icon.png",
        title:"Reviews.io",
        img2:"./assests/images/stars-45.png",
        p:4.7,
        sub:5,
    },
    
   
]

export default RatingSectionData